const getProfileList = state => state.profileList;


export default {
  getProfileList,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/getters.js